var metadata               = require('./_metadata')
  , anObject               = require('./_an-object')
  , ordinaryHasOwnMetadata = metadata.has
  , toMetaKey              = metadata.key;

metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});


//////////////////
// WEBPACK FOOTER
// /Users/mundofr/GitHub/Angle/ChipinqueTrails/~/core-js/modules/es7.reflect.has-own-metadata.js
// module id = ../../../../core-js/modules/es7.reflect.has-own-metadata.js
// module chunks = 0